<div class="grid grid-column">
  <div class="section full-width hidden block-md">
    <div class="section-content">
      <app-mobile-app-banner></app-mobile-app-banner>
    </div>
  </div>

  <div class="section full-width relative">
    <div class="section-content">
      <div
        class="py-12 grid align-items-center justify-content-between"
      >
        <div class="grid-item grid-md-grow">
          <div class="grid grid-gutter-24 align-items-center justify-content-md-between">
            <div class="grid-item city-selector-container">
              <div class="grid align-items-center">
                <div
                  class="icon icon-16 icon-global mr-4 grid-item"
                  style="top: 0"
                ></div>
                <span
                  class="link typography typography-caption typography-medium gray-800 grid-item"
                  (click)="openCityModal()"
                  ymGoal
                  [nameGoal]="YmGoalHeader.SelectCityClick"
                >
                  <span data-testid="current-city">
                    {{ storage.cityName$ | async }}
                  </span>
                  <span
                    class="icon icon-chevron-down ml-4"
                    style="font-size: 0.6em; font-weight: 700"
                  ></span>
                </span>
              </div>
            </div>

            <div class="grid-item">
              <div class="grid grid-gutter-20 grid-nowrap">

                <div data-testid="header-nav-for-clients" class="hidden-sm grid-item">
                  <a
                    routerLink="/"
                    class="typography typography-medium bg-gray-100 gray-800 tag tag-m tag-rounded"
                  >
                    Клиентам
                  </a>
                </div>

                <div class="hidden-sm grid-item"
                  *ngFor="let item of headerNavItems$ | async"
                >
                  <ng-container 
                    *ngTemplateOutlet="link; context: { item: item }">
                  </ng-container>
                </div>

                <div class="hidden-sm grid-item">
                  <div data-testid="header-nav-about-company" class="dropdown-container tag tag-m tag-rounded cursor-pointer">
                    <span class="dropdown-trigger nowrap">
                      <span>
                        О Компании
                      </span>
                    </span>
                    <div class="dropdown dropdown-menu nowrap">
                      <a
                        *ngFor="let item of aboutCompanyNavItems"
                        [routerLink]="item.link"
                        class="dropdown-item"
                        [attr.data-testid]="item.testId"
                      >
                        {{ item.name }}
                      </a>
                    </div>
                  </div>
                </div>

                <div class="grid-item hidden block-sm">
                  <div class="dropdown-container tag tag-m tag-rounded bg-gray-100 cursor-pointer">
                    <span class="dropdown-trigger nowrap" data-testid="adaptive-header-nav-for-clients">
                      <a routerLink="/" class="typography typography-medium adaptive-header-nav-for-clients-link">
                        Клиентам
                      </a>
                    </span>
                    <div class="dropdown dropdown-menu nowrap">
                      <a
                        *ngFor="let item of headerNavItems$ | async"
                        [href]="item.link"
                        (click)="ymReachGoal(item.ymGoalName)"
                        [attr.data-testid]="item.testId"
                        class="dropdown-item"
                      >
                        {{ item.name }}
                      </a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="grid-item grid align-items-center">
          <div
            class="typography typography-headline gray-700 grid-item hidden-lg"
          >
            <div *ngIf="phoneNumbers$ | async as phoneNumbers"
              class="grid align-items-center"
            >
              <div
                class="icon icon-phone icon-20 mr-4 grid-item"
                style="top: 0"
              ></div>

              <div
                class="grid-item"
                *ngIf="phoneNumbers.company as companyPhone"
              >
                <a [href]="'tel:' + companyPhone">{{ companyPhone }}</a
                >&nbsp;&nbsp;
              </div>

              <div
                class="grid-item"
                *ngIf="phoneNumbers.federal as federalPhone"
              >
                <a [href]="'tel:' + federalPhone">{{ federalPhone }}</a>
              </div>
            </div>
          </div>

          <app-visually-impaired-button
            class="ml-20 grid-item hidden-md"
            *ngIf="!(visuallyImpaired.stateVI$ | async)"
            (click)="switchOnVI()"
          ></app-visually-impaired-button>
        </div>
      </div>
    </div>
  </div>

  <div class="section bg-blue-light">
    <div class="section-content">
      <div class="py-16 grid grid-gutter-24 align-items-center">
        <div class="grid-item hidden block-md">
          <a routerLink="/">
            <svg
              width="96"
              height="32"
              viewBox="0 0 96 32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.40713 26.6442H11.863C17.4192 29.7798 23.8777 31.2307 27.4394 31.6051C28.3416 31.7455 28.8641 31.7455 28.8641 31.7455C25.3498 31.0903 20.0311 29.3586 15.4721 26.7846C11.9104 24.7722 8.68113 22.2449 6.7341 19.2964C4.64457 16.1139 3.45734 12.8379 3.2199 10.0298C2.98245 7.17502 3.69479 4.78814 5.30942 3.43091C7.01903 2.02688 9.0136 1.37167 11.1506 1.23127C8.30122 0.997263 5.45188 1.60567 3.2199 3.47771C-0.104348 6.23897 -0.151838 13.9611 4.40713 20.2792C4.40713 20.326 4.45462 20.326 4.45462 20.3729V26.6442H4.40713ZM28.8166 25.0998V19.9516C28.1517 20.5601 27.0595 20.9345 25.7298 21.0748C23.9727 21.2153 21.8832 20.8876 19.7461 19.9985C19.1763 19.7644 18.6064 19.4836 18.084 19.2028C15.6146 17.8456 13.5725 15.88 12.2429 13.8675C10.9131 11.8551 10.3433 9.74907 10.8657 8.2514C11.388 7.3154 12.0529 6.75378 12.7652 6.42617C13.4776 6.09857 14.2849 6.00496 15.1397 6.05177C15.947 6.09856 16.8018 6.33257 17.6566 6.66018C18.6064 7.03457 19.5087 7.54942 20.411 8.11102C21.2658 8.67262 22.0256 9.3746 22.6905 10.0767C23.4028 10.8723 23.9727 11.7147 24.4001 12.5103C24.8275 13.3527 25.0649 14.1951 25.0649 14.8972C25.0649 15.5055 24.875 16.0204 24.4001 16.4416C24.0202 16.6756 23.4503 16.7224 22.7854 16.6288C22.0256 16.4883 21.1708 16.1139 20.316 15.646C19.4612 15.1311 18.7013 14.5227 18.084 13.8207C17.4667 13.1655 17.0393 12.4635 16.8018 11.8083C16.2795 10.0767 17.1817 9.46824 17.9415 9.28104C18.3214 9.18741 18.6539 9.14066 18.7963 9.14066H18.8439L19.6512 9.04702L18.9388 8.71944C18.8914 8.71944 18.3689 8.6258 17.7991 8.6258C17.3717 8.67262 16.8968 8.71944 16.4694 8.90664C15.9945 9.09384 15.6146 9.42142 15.3296 9.93627C15.1397 10.3107 15.0447 10.7786 15.0922 11.3402C15.1872 12.3231 15.7095 13.3995 16.5168 14.3823C17.3717 15.412 18.4639 16.348 19.7461 17.05C20.9808 17.752 22.3105 18.0796 23.4978 18.1732C24.7325 18.22 25.7772 17.9392 26.3946 17.3308C26.4896 17.2372 26.5846 17.0968 26.6796 17.0032C27.4394 15.9267 27.3444 14.5227 26.6796 13.0719C26.0147 11.6679 24.875 10.1702 23.4503 8.85982C22.6905 8.15784 21.9306 7.5026 21.0759 6.94098C20.3635 6.42617 19.6037 6.00496 18.8439 5.58375C17.1342 4.69454 15.3296 4.13293 13.6675 4.17973C12.0054 4.17973 10.4857 4.78814 9.3935 6.28577C9.25106 6.51977 9.06103 6.75378 8.91858 7.03457C7.92131 8.95346 8.30122 11.3871 9.63096 13.8207C11.0556 16.3948 13.525 18.9688 16.4694 20.8876C19.9361 23.1341 23.8302 24.2573 26.2997 24.7254C26.822 24.8657 28.1992 25.0998 28.8166 25.0998ZM28.8166 12.4635V1.65248H15.4721C17.7991 2.21408 20.0311 3.29051 21.9781 4.69454C24.685 6.66018 27.2494 9.42142 28.7216 12.2295C28.7691 12.2763 28.7691 12.3699 28.8166 12.4635Z"
                fill="#00BE6E"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M48.4295 1.69531V29.0739H45.6751V15.3612H40.1189V29.0739H37.3645V1.69531H40.1189V12.6468H45.6751V1.69531H48.4295ZM55.2204 4.40977V12.5999H61.0141V15.3144H55.2204V26.3126H62.4388V29.0739H52.4186V1.69531H62.4388V4.40977H55.2204ZM75.3084 26.3126V29.0739H65.3357V1.69531H68.09V26.3126H75.3084ZM80.0096 29.1206H77.2553V1.74212H80.0096V29.1206ZM91.1696 14.0975L95.2538 29.0739H92.4042L89.0329 16.0632L85.7082 29.0739H82.812L86.8955 14.0975L82.764 1.69531H85.7562L89.0329 12.2255L92.3096 1.69531H95.2538L91.1696 14.0975Z"
                fill="var(--text-color)"
              />
            </svg>
          </a>
        </div>

        <div class="grid-item hidden-md">
          <a routerLink="/">
            <svg
              width="144"
              height="44"
              viewBox="0 0 144 44"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.24327 38.2988H16.8057c7.8713 4.5075 17.0209 6.5931 22.0666 7.1313 1.2782.2018 2.0183.2018 2.0183.2018-4.9785-.9418-12.5134-3.4311-18.9719-7.1313-5.0458-2.8928-9.6206-6.5258-12.37889-10.7642-2.96016-4.5748-4.64207-9.2841-4.97845-13.3207-.33639-4.1038.67277-7.53494 2.96016-9.48596 2.42195-2.01829 5.24758-2.96016 8.27498-3.16198-4.0366-.33639-8.07316.5382-11.23514 3.22926C-.147988 8.96632-.215265 20.0669 6.24327 29.1492c0 .0673.06728.0673.06728.1346v9.015h-.06728Zm34.58003-2.2201v-7.4004c-.9419.8746-2.4892 1.4128-4.3729 1.6146-2.4893.2019-5.4494-.2691-8.4769-1.5473-.8073-.3364-1.6146-.7401-2.3546-1.1437-3.4984-1.951-6.3913-4.7766-8.275-7.6695-1.8838-2.8929-2.6911-5.9203-1.951-8.0732.74-1.3455 1.6819-2.15284 2.691-2.62377 1.0092-.47093 2.1529-.60549 3.3638-.53821 1.1437.06727 2.3547.40365 3.5657.87459 1.3455.53819 2.6237 1.27829 3.902 2.08559 1.211.8073 2.2874 1.8164 3.2293 2.8256 1.0091 1.1437 1.8164 2.3547 2.4219 3.4984.6055 1.2109.9419 2.4219.9419 3.4311 0 .8745-.2691 1.6146-.9419 2.2201-.5382.3364-1.3455.4036-2.2874.2691-1.0764-.2019-2.2874-.7401-3.4984-1.4128-1.2109-.7401-2.2874-1.6147-3.1619-2.6238-.8746-.9419-1.4801-1.951-1.8165-2.8929-.74-2.4892.5382-3.3638 1.6146-3.6329.5382-.1346 1.0092-.2018 1.211-.2018h.0673l1.1437-.1346-1.0092-.4709c-.0672 0-.8073-.1346-1.6146-.1346-.6055.0673-1.2782.1346-1.8837.4037-.6728.2691-1.211.74-1.6147 1.4801-.2691.5382-.4036 1.2109-.3364 2.0182.1346 1.4128.8746 2.9602 2.0183 4.373 1.211 1.4801 2.7584 2.8256 4.5748 3.8348 1.7492 1.0091 3.6329 1.48 5.3149 1.6146 1.7491.0673 3.2292-.3364 4.1038-1.211.1346-.1345.2691-.3364.4037-.4709 1.0764-1.5474.9418-3.5657 0-5.6512-.9419-2.0183-2.5565-4.1712-4.5748-6.0549-1.0764-1.0091-2.1529-1.951-3.3638-2.75833-1.0092-.74004-2.0856-1.34553-3.162-1.95102-2.422-1.27825-4.9785-2.08556-7.3331-2.01829-2.3547 0-4.5076.8746-6.0549 3.02744-.2018.33638-.471.67276-.6728 1.0764-1.4128 2.7584-.8746 6.2567 1.0092 9.7551 2.0183 3.7002 5.5166 7.4004 9.6878 10.1587 4.9111 3.2293 10.4278 4.8439 13.9262 5.5167.74.2018 2.691.5382 3.5656.5382Zm0-18.1646V2.37324H21.9187c3.2965.80731 6.4585 2.35467 9.2168 4.37296 3.8348 2.82561 7.4677 6.7949 9.5533 10.8315.0672.0673.0672.2018.1345.3364Z"
                fill="#00BE6E"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M68.6085 2.4375v39.3567h-3.902v-19.712h-7.8714v19.712h-3.902V2.4375h3.902v15.7427h7.8714V2.4375h3.902ZM78.229 6.33953V18.1129h8.2077v3.902H78.229v15.81h10.226v3.9693H74.2597V2.4375H88.455v3.90203H78.229ZM106.687 37.8249v3.9693H92.5589V2.4375h3.902v35.3874h10.2261ZM113.347 41.8614h-3.902V2.50478h3.902V41.8614ZM129.157 20.2657l5.786 21.5285h-4.037l-4.776-18.7029-4.71 18.7029h-4.103l5.785-21.5285-5.853-17.8282h4.239l4.642 15.1372 4.642-15.1372h4.171l-5.786 17.8282Z"
                fill="var(--text-color)"
              />
            </svg>
          </a>
        </div>

        <div class="grid-item grid-grow hidden-xs grow">
          <div class="relative">
            <app-helix-searcher
              [isMobile]="false"
              *ngIf="!shouldShowMobileSearch"
            ></app-helix-searcher>
          </div>
        </div>

        <div
          class="grid-item hidden block-md grid-xs-grow justify-content-sm-end"
        >
          <div
            class="grid grid-gutter-48 grid-nowrap justify-content-end align-items-center"
          >
            <div class="grid-item">
              <a
                [href]="'tel:' + (storage.federalPhone$ | async)"
                class="icon icon-phone icon-24 hidden block-md"
              ></a>
            </div>
            <div class="grid-item">
              <span
                ymGoal
                [nameGoal]="YmGoalHeader.CartButtonClick"
                class="icon icon-cart icon-24 cursor-pointer"
                (click)="updateHxidsAndGoToCart()"
                data-testid="adaptive-header-nav-cart-button"
              >
                <div
                  class="badge"
                  [innerText]="repository.count$ | async"
                ></div>
              </span>
            </div>

            <ng-container
              *ngIf="!(repository.userInfoService.userNickName$ | async)"
            >
              <div class="grid-item" *ngIf="loginLink$ | async as loginLink">
                <div class="hidden-xs">
                  <a
                    class="button button-primary button-s"
                    [href]="loginLink"
                    (click)="ymReachGoal(YmGoalHeader.LoginLkk)"
                  >
                    Войти
                  </a>
                </div>

                <div class="hidden block-xs">
                  <a
                    class="login-button-xs button button-primary button-xs"
                    [href]="loginLink"
                    (click)="ymReachGoal(YmGoalHeader.LoginLkk)"
                    data-testid="adaptive-header-nav-enter-personal-account"
                  >
                    Войти
                  </a>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <ng-container
          *ngIf="!(repository.userInfoService.userNickName$ | async)"
        >
          <div
            class="grid-item hidden-md"
            *ngIf="loginLink$ | async as loginLink"
          >
            <a
              class="button button-primary button-s"
              [href]="loginLink"
              (click)="ymReachGoal(YmGoalHeader.LoginLkk)"
              data-testid="header-nav-personal-account"
            >
              Личный кабинет
            </a>
          </div>
        </ng-container>

        <div class="grid-item hidden-md">
          <span
            ymGoal
            [nameGoal]="YmGoalHeader.CartButtonClick"
            class="icon icon-cart icon-24 cursor-pointer"
            (click)="updateHxidsAndGoToCart()"
            data-testid="header-nav-cart-button"
          >
            <div class="badge" [innerText]="repository.count$ | async"></div>
          </span>
        </div>

        <div
          class="grid-item"
          *ngIf="
            repository.userInfoService.userNickName$ | async as userNickName
          "
        >
          <app-user-info-button
            [userNickName]="userNickName"
            [profileInfo]="repository.userInfoService.profileInfo$ | async"
            [personalAccount]="personalAccount$ | async"
            [loginLink]="loginLink$ | async"
          >
          </app-user-info-button>
        </div>

        <div class="grid-item hidden block-xs grid-12">
          <div class="relative">
            <app-helix-searcher
              [isMobile]="true"
              *ngIf="shouldShowMobileSearch || platform.isServer"
            ></app-helix-searcher>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="section hidden-md">
  <div class="section-content">
    <div class="py-20 grid justify-content-between">
      <div *ngFor="let item of clientNavItems$ | async" class="grid-item">
        <a *ngIf="!item.items; else itemWithDropdown"
          [routerLink]="item.link"
          [state]="{ ymGoalName: item.ymGoalName }"
          [attr.data-testid]="item.testId"
          class="typography typography-headline typography-medium grey-800"
        >
          {{ item.name }}
        </a>
        <ng-template #itemWithDropdown>
          <app-nav-menu-item-with-dropdown [title]="item.name" [link]="item.link"
            [alignRight]="item.alignRight" [vpWidth]="item.vpWidth" [minHeightPx]="item.minHeightPx"
            [items]="item.items!" [itemColumns]="item.itemColumns"
            [testId]="item.testId" [moreInfo]="item.moreInfo">
          </app-nav-menu-item-with-dropdown>
        </ng-template>
      </div>

    </div>
  </div>
</div>

<ng-template #link let-item="item" >
  <a
    *ngIf="isAbsoluteLink(item.link); else clientRoutingLink"
    [href]="item.link"
    (click)="ymReachGoal(item.ymGoalName)"
    [attr.data-testid]="item.testId"
    class="typography tag tag-m tag-rounded">
    {{ item.name }}
  </a>
  <ng-template #clientRoutingLink>
      <a [routerLink]="item.link"
        (click)="ymReachGoal(item.ymGoalName)"
        [attr.data-testid]="item.testId"
        class="typography tag tag-m tag-rounded">
        {{ item.name }}
      </a>
  </ng-template>
</ng-template>
